export default __webpack_public_path__ + "static/media/icon-jungle-frog.adf5cb7e.svg";